<div
    class="h-[200vh] w-screen relative z-[5] pointer-events-none overflow-x-hidden"
>
    <svg
        class="w-[250vw] md:w-[102vw] h-[100vh] absolute bottom-0 -right-[10vw] md:-right-[3px]"
        viewBox="0 0 1453 1027"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
    >
        <g style="mix-blend-mode:multiply">
            <path
                d="M4 212.851C22.2514 130.328 141.228 277.733 212.864 274.308C362.889 267.412 405.861 0 649.174 0C832.75 0 833.813 276.795 1016.92 305.178C1161.51 327.603 1228.68 50.4799 1312.76 17.9213C1378.88 -7.74087 1400.88 61.0825 1448.93 57.1886V909.529H4V212.851Z"
                fill="#FDEFD5"
            />
        </g>
        <g filter="url(#filter0_d_446_243)">
            <path
                d="M4 236.308C22.2514 153.785 141.228 301.19 212.864 297.813C362.889 290.869 405.861 23.4573 649.174 23.4573C832.75 23.4573 833.813 300.252 1016.92 328.682C1161.51 351.06 1228.68 73.9841 1312.76 41.3786C1378.88 15.7164 1400.88 84.5398 1448.93 80.6459V932.986H4V236.308Z"
                fill="#DDEAEB"
            />
        </g>
        <path
            d="M4 304.944C95.6111 327.134 155.583 407.076 227.219 403.98C377.174 397.646 407.254 79.7546 650.567 79.7546C834.096 79.7546 861.697 364.384 1044.87 390.515C1189.47 411.299 1250.43 132.252 1335.67 121.368C1402.37 112.829 1449 161.855 1449 161.855V946.404H4V304.944Z"
            fill="#B8D9DD"
        />
        <path
            d="M4 382.728C96.5556 416.224 169.278 510.991 240.796 510.991C439.129 510.991 446.213 155.943 633.472 155.943C816.978 155.943 833.813 441.605 1016.99 467.736C1161.58 488.332 1252.46 211.302 1337.84 206.048C1449 199.292 1449 239.263 1449 239.263V1024H4V382.728Z"
            fill="#91CDD2"
        />
        <path
            opacity="0.39"
            d="M716.347 532.763C871.236 503.253 875.203 659.197 1054.29 593.751C1196.08 541.864 1168.78 557.93 1280.96 475.549C1384.57 399.407 1449.07 510.5 1449.07 510.5V1027H4V612.5C4 612.5 113.111 751.323 394 691.5C596 630 627.003 549.746 716.347 532.763Z"
            fill="url(#paint0_linear_446_243)"
        />
        <path
            d="M489.823 282.659C494.921 282.659 499.055 274.446 499.055 264.315C499.055 254.185 494.921 245.972 489.823 245.972C484.724 245.972 480.591 254.185 480.591 264.315C480.591 274.446 484.724 282.659 489.823 282.659Z"
            fill="#B8D9DD"
        />
        <path
            d="M475.987 328.4C478.53 328.4 480.591 324.304 480.591 319.252C480.591 314.199 478.53 310.104 475.987 310.104C473.444 310.104 471.383 314.199 471.383 319.252C471.383 324.304 473.444 328.4 475.987 328.4Z"
            fill="#B8D9DD"
        />
        <path
            d="M320.036 549.883C325.134 549.883 329.268 541.67 329.268 531.54C329.268 521.409 325.134 513.196 320.036 513.196C314.937 513.196 310.804 521.409 310.804 531.54C310.804 541.67 314.937 549.883 320.036 549.883Z"
            fill="#B8D9DD"
        />
        <path
            d="M1044.87 409.047C1049.97 409.047 1054.1 400.834 1054.1 390.703C1054.1 380.572 1049.97 372.359 1044.87 372.359C1039.77 372.359 1035.64 380.572 1035.64 390.703C1035.64 400.834 1039.77 409.047 1044.87 409.047Z"
            fill="#DDEAEB"
        />
        <path
            d="M1210.72 568.18C1213.26 568.18 1215.32 564.084 1215.32 559.032C1215.32 553.979 1213.26 549.883 1210.72 549.883C1208.17 549.883 1206.11 553.979 1206.11 559.032C1206.11 564.084 1208.17 568.18 1210.72 568.18Z"
            fill="#DDEAEB"
        />
        <path
            d="M196.053 514.885C201.152 514.885 205.285 506.673 205.285 496.542C205.285 486.411 201.152 478.198 196.053 478.198C190.955 478.198 186.821 486.411 186.821 496.542C186.821 506.673 190.955 514.885 196.053 514.885Z"
            fill="#B8D9DD"
        />
        <path
            d="M1197.19 595.906C1201.44 595.906 1204.88 589.059 1204.88 580.612C1204.88 572.165 1201.44 565.318 1197.19 565.318C1192.94 565.318 1189.49 572.165 1189.49 580.612C1189.49 589.059 1192.94 595.906 1197.19 595.906Z"
            fill="#DDEAEB"
        />
        <path
            d="M1446 814.241C1353.64 825.355 1281.07 856.796 1209.7 856.796C1011.77 856.796 1004.71 739 817.835 739C634.71 739 617.91 833.776 435.116 842.445C290.821 849.278 200.131 757.367 114.93 755.623C4.00005 753.382 4.00004 766.644 4.00004 766.644V1027H1446V814.241Z"
            fill="url(#paint1_linear_446_243)"
        />
        <defs>
            <filter
                id="filter0_d_446_243"
                x="0"
                y="23.4573"
                width="1452.93"
                height="917.529"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_446_243"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_446_243"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_446_243"
                x1="726.535"
                y1="322"
                x2="726.535"
                y2="894.378"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#B8D9DD" />
                <stop offset="1" stop-color="#EAFEFF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_446_243"
                x1="725"
                y1="739"
                x2="725"
                y2="1027"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#EAFEFF" stop-opacity="0.11" />
                <stop offset="0.739583" stop-color="#E3FAFD" />
            </linearGradient>
        </defs>
    </svg>
</div>
